<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [defaultHeight]="30"
  [isShowModal]="false"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="formGroup">
      <ssg-tabset (tabChange)="selectTab($event)">
        <ssg-tab class="content-tab" tabTitle="بابت">
          <editable-grid
            #Concern
            *ngIf="isActveTab('بابت')"
            [columns]="TrsVoucherKindConcerns"
            [(dataList)]="model.TrsVoucherKindConcerns"
            [DefaultValues]="DefaultValues"></editable-grid>
        </ssg-tab>
        <ssg-tab class="content-tab" tabTitle="اسناد مبنا مجاز">
          <editable-grid
            #ReferenceVoucherKind
            *ngIf="isActveTab('اسناد مبنا مجاز')"
            [columns]="TrsReferenceVoucherKinds"
            [(dataList)]="model.TrsReferenceVoucherKinds"
            [DefaultValues]="DefaultValues"></editable-grid>
        </ssg-tab>
        <ssg-tab class="content-tab" tabTitle="انواع تفصیلی">
          <editable-grid
            #VoucherKindDetailLedgerKind
            *ngIf="isActveTab('انواع تفصیلی')"
            [columns]="TrsVoucherKindDetailLedgerKinds"
            [(dataList)]="model.TrsVoucherKindDetailLedgerKinds"
            [DefaultValues]="DefaultValues"></editable-grid>
        </ssg-tab>
        <ssg-tab class="content-tab" tabTitle="انواع تفصیلی خزانه">
          <editable-grid
            #VoucherKindTreasuryDetailLedgerKind
            *ngIf="isActveTab('انواع تفصیلی خزانه')"
            [columns]="TrsVoucherKindTreasuryDetailLedgerKinds"
            [(dataList)]="model.TrsVoucherKindTreasuryDetailLedgerKinds"
            [DefaultValues]="DefaultValues"></editable-grid>
        </ssg-tab>
        <ssg-tab tabTitle="اطلاعات تکمیلی">
          <form-control-model [columns]="detailsColumns" [defaultHeight]="30" [group]="formGroup" [model]="model"> </form-control-model>
        </ssg-tab>
      </ssg-tabset>
  </ng-container>
</dynamic-form>
